export default "__VITE_ASSET__cd7c1377__"